// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:400px){.email-section[data-v-3918007e]  .form-input .input-group .append{bottom:calc(100% + 10px);right:0}}", ""]);
// Exports
module.exports = exports;
